module.exports = __webpack_public_path__ + "img/ilustracion-send-message.1f4c26f6.svg";